import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import classnames from "classnames";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import {AppCheckbox} from "../../components/AppCheckbox";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import useDefaultFeeStateHook from "../../hooks/useDefaultFeeStateHook";
import Button from "@mui/material/Button";
import {useDefaultQuoteSettingsContext} from "../../contexts/DefaultQuoteSettingsContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const DefaultSettingFee = ({ fee, isLoading }) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [feeState, setFeeStateWithUpdate] = useDefaultFeeStateHook(fee)
    const { quoteSettings, setSettingsStateWithUpdate, updateQuoteSettingsResponse } = useDefaultQuoteSettingsContext()

    const deleteFee = () => {
        let newQuoteSettings = structuredClone(quoteSettings)
        newQuoteSettings.fees = newQuoteSettings.fees.filter(f => f.id !== fee.id)
        setSettingsStateWithUpdate(newQuoteSettings, true)
    }

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!feeState) return null;

    const isFinanced = feeState.is_capped

    return (
        <TableRow
            key={fee.id}
            sx={{
                '&:last-child td, &:last-child th': {border: 0},
                height: '10px',
            }}
            className={'default-settings-fee'}
        >

            <TableCell
                className={'DealPageFee fee-name'}
                scope="row"
                size={'small'}
                width={'60%'}
                align="left"
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {feeState.name}
                    <Button
                        style={{
                            alignSelf: 'end'
                        }}
                        color="error"
                        onClick={deleteFee}
                        className={'default-settings-fee__remove-button'}

                    >
                        Remove
                    </Button>
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        className={'DealPageFee'}
                        align="center"
                        size={'small'}
                        width={'20%'}
                    >
                        <AppCheckbox
                            disabled={isLoading}
                            checked={feeState.is_taxed}
                            onChange={() => {
                                setFeeStateWithUpdate({is_taxed: !feeState.is_taxed}, true, true)
                            }}
                        />

                    </TableCell>
                    <TableCell
                        className={'DealPageFee'}
                        align="center"
                        size={'small'}
                        width={'20%'}
                    >
                        <Tooltip title={isFinanced ? 'Upfront' : 'Cap'} arrow placement={'top'}>
                            <Switch
                                disabled={isLoading || fee.name === 'Registration Fee'}
                                checked={isFinanced}
                                onChange={() => {
                                    setFeeStateWithUpdate({is_capped: !feeState.is_capped, is_tax_capped: !feeState.is_capped}, true, true)
                                }}
                            />
                        </Tooltip>
                    </TableCell>
                </React.Fragment>
            }
            <TableCell
                align="right"
                size={'small'}
                className={'DealPageFee'}
                width={'60%'}
            >
                <div
                    style={{
                        display: isTabletOrMobile ? 'flex' : '',
                        flexDirection: isTabletOrMobile ? "row" : '',
                        alignItems: isTabletOrMobile ? 'center' : '',
                        justifyContent: isTabletOrMobile ? 'end' : ''
                    }}
                >
                    <div className={'fee-input-wrap'}>
                        <span className={'prefix'}>$</span>
                        <CustomCurrencyInput
                            onChange={(value) => setFeeStateWithUpdate({amount: value}, true, false)}
                            className={classnames({ loading: isLoading })}
                            value={feeState.amount}
                            key={fee.Id}
                            allowNull={false}
                            InputProps={{}}
                        />
                    </div>
                    {
                        isTabletOrMobile &&
                        <div>
                            <MoreVertIcon onClick={handleClick}/>
                            <Popover
                                onClick={(e) => e.stopPropagation()}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Taxable
                                    </Typography>
                                    <Switch
                                        disabled={isLoading}
                                        checked={feeState.is_taxed}
                                        onChange={() => {
                                            setFeeStateWithUpdate({is_taxed: !feeState.is_taxed}, true, true)
                                        }}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Capped
                                    </Typography>
                                    <Switch
                                        disabled={isLoading || fee.name === 'Registration Fee'}
                                        checked={feeState.is_capped}
                                        onChange={() => {
                                            setFeeStateWithUpdate({is_capped: !feeState.is_capped}, true, true)
                                        }}
                                    />
                                </Stack>
                            </Popover>
                        </div>
                    }
                </div>
            </TableCell>
        </TableRow>
)
}